import { useMutation } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	BulkAddCounterpartyPreviewDto,
	BulkAddCounterpartyPreviewRes,
} from '@dealstack/shared/lib/generated';

export const useBulkAddCounterpartyPreview = ({
	dealId,
	programmeId,
	onSettled,
}: {
	dealId: string;
	programmeId: string;
	onSettled?: () => void;
}) => {
	const tMipManage = useTranslationMipManage();

	const handleError = () => {
		showToastV2({
			state: 'error',
			title: tMipManage('documents_page.toast.add_counterparty.error'),
		});
	};

	return useMutation({
		mutationFn: async (body: BulkAddCounterpartyPreviewDto) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_ADD_COUNTERPARTY_PREVIEW_POST,
				{ dealId, programmeId }
			);
			const response = await makeRequest<ApiV1.Response<BulkAddCounterpartyPreviewRes>>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});
			return response;
		},
		onError: handleError,
		onSettled,
	});
};
